import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["downPayment", "realEstatePrice", "realEstateIncludedRadio", "output"];
  static values = { url: String };

  connect () {
    this.debounceTimer = null;
  }

  disconnect () {
    clearTimeout(this.debounceTimer);
  }

  recalculate () {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => this.fetchCashAtClose(), 300);
  }

  async fetchCashAtClose () {
    const params = new URLSearchParams({
      down_payment: this.downPaymentParam(),
      real_estate: this.realEstateParam(),
      real_estate_price: this.realEstatePriceParam(),
    });

    try {
      const response = await fetch(`${this.urlValue}?${params}`, {
        headers: { Accept: "application/json" },
      });

      if (response.ok) {
        const data = await response.json();
        this.outputTarget.value = data.cash_at_close_cents;
      }
    } catch {
      this.outputTarget.value = "ERROR";
    }
  }

  downPaymentParam () {
    return this.downPaymentTarget.value || "0";
  }

  realEstateParam () {
    if (this.hasRealEstateIncludedRadioTarget) return this.realEstateIncludedRadioTarget.checked;

    return false;
  }

  realEstatePriceParam () {
    if (this.realEstateParam() && this.hasRealEstatePriceTarget) {
      return this.realEstatePriceTarget.value || "0";
    }

    return "0";
  }
}
